import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import styles from './AmbulatoryQuote.module.sass'

const AmbulatoryQuoteTotalsTable = ({ sellPrice }) => {
	const { i18n } = useGlobal()

	return (
		<table className={`${styles['styled-table']} ${styles['--total']}`}>
			<thead>
				<tr>
					<th>{i18n`sellPrice`}</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>
						<strong>{sellPrice}</strong>
					</td>
				</tr>
			</tbody>
		</table>
	)
}

export default AmbulatoryQuoteTotalsTable
